const serverIpAddress = "https://accdev.axity.com";

export const environment = {
  production: false,
  baseUrl: `${serverIpAddress}/api/v2`,
  webPage: 'https://accdevmkt.axity.com',
  aniversaryDate: "startDate",
  firebase: {
    apiKey: "AIzaSyBmx0xP9o8iyWQDNQyai49_q5unZuVaC88",
    authDomain: "toks-dev-cc043.firebaseapp.com",
    projectId: "toks-dev-cc043",
    storageBucket: "toks-dev-cc043.appspot.com",
    messagingSenderId: "849717367424",
    appId: "1:849717367424:web:83d349603ca755e374cc65",
    measurementId: "G-MMKJGJJ1T6",
  },
  salesforce: {
    orgId: '00DHu000003NWta',
    scrt2URL: 'https://loyaltysfgrg.my.salesforce-scrt.com',
    guest: {
      deploymentName: 'SC_AComerClubWeb',
      baseURL: 'https://loyaltysfgrg.my.site.com/ESWSCAComerClubWeb1754435120512',
    }
  },
  mercadopago: {
    publicKey: "TEST-c9a7830a-bfcb-415f-8c60-8b5ec453e0fa",
  },
};
